import {Component, Input, OnInit} from '@angular/core';
import {SpinnerService} from "../../../modules/spinner/spinner.service";
import {MatDialog} from "@angular/material/dialog";
import {SnackBarService} from "../../shared-components/snack-bar/snack-bar.service";
import {ConfigTurnsService} from "../../../services/turns-services/config-turns-service/config-turns.service";
import {ImageDialogComponent} from "../../shared-components/image-dialog/image-dialog.component";
import {
  MultimediaManagerComponent
} from "../../../modules/multimedia-manager/multimedia-manager/multimedia-manager.component";
import {BroadcastingsService} from "../../../services/broadcastings-services/broadcastings.service";
import {UserStorageService} from "../../../services/user-storage-service/user-storage.service";
import {FormControl, FormGroup} from "@angular/forms";
import {tap} from "rxjs/internal/operators/tap";
import {catchError} from "rxjs/internal/operators/catchError";
import {EMPTY} from "rxjs";
import {Subscription} from "rxjs/internal/Subscription";

@Component({
  selector: 'app-broadcastings-config-ui-background-image-card',
  templateUrl: './broadcastings-config-ui-background-image-card.component.html',
  styleUrls: ['./broadcastings-config-ui-background-image-card.component.scss']
})
export class BroadcastingsConfigUiBackgroundImageCardComponent implements OnInit {

  @Input() config;
  @Input() title: string;
  @Input() width: string;
  @Input() height: string;
  showSpinner: boolean;
  centers;
  image;

  getBroadcastingLayoutsSubscription: Subscription;

  basicDataForm = new FormGroup({
    selectedCenter: new FormControl(null)
  });

  constructor(private userStorageService: UserStorageService,
              private spinnerService: SpinnerService,
              private dialog: MatDialog,
              private snackbarService: SnackBarService,
              private broadcastingsService: BroadcastingsService) {
    this.centers = this.userStorageService.getCenterList();
  }

  ngOnInit() {
    this.showSpinner = false;
  }

  public getBroadcastCenterConfig() {
    this.basicDataForm.get('selectedCenter').value.InternalId
    this.getBroadcastingLayoutsSubscription = this.broadcastingsService.getBroadcastCenterConfig(this.basicDataForm.get('selectedCenter').value.InternalId).pipe(
      tap(o => {
        this.config = o;
        this.image = this.config.backgroundImageUrl;
      }),
      catchError(error => { this.snackbarService.open(error['error']['message'], 'error'); return EMPTY; })
    ).subscribe();
  }

  public updateBroadcastCenterBackgroundImage(imageUrl) {
    this.showSpinner = true;
    this.spinnerService.show('turn-config-image-spinner');
    this.broadcastingsService.updateBroadcastCenterConfigBackgroundImage(
      this.basicDataForm.get('selectedCenter').value.InternalId,
      imageUrl
    ).subscribe(
      (res) => {
        this.showSpinner = false;
        this.spinnerService.hide('turn-config-image-spinner');
        this.getBroadcastCenterConfig();
        // this.broadcastingsService.refreshConfig();
        this.snackbarService.open('validation-images.snackbar messages.update image success', 'success');
      },
      (error) => {
        this.showSpinner = false;
        this.spinnerService.hide('turn-config-image-spinner');
        this.snackbarService.open(error['error']['message'], 'error');
      }
    );
  }

  public deleteAsset() {
    this.showSpinner = true;
    this.spinnerService.show('turn-config-image-spinner');
    this.broadcastingsService.updateBroadcastCenterConfigBackgroundImage(
      this.basicDataForm.get('selectedCenter').value.InternalId,
      null
    ).subscribe(
      (res) => {
        this.showSpinner = false;
        this.spinnerService.hide('turn-config-image-spinner');
        this.getBroadcastCenterConfig();
        // this.broadcastingsService.refreshConfig();
        this.snackbarService.open('validation-images.snackbar messages.update image success', 'success');
      },
      (error) => {
        this.showSpinner = false;
        this.spinnerService.hide('turn-config-image-spinner');
        this.snackbarService.open(error['error']['message'], 'error');
      }
    );
  }

  public zoom() {
    const dialogRef = this.dialog.open(ImageDialogComponent, { data: { image: this.image, info: { title: this.title, subtitle: this.width + 'x' + this.height }}});
    dialogRef.afterClosed().subscribe(res => {
      if (res) {
        if (res === 'upload') {
          this.uploadPhotoClicker();
        } else if (res === 'delete') {
          this.deleteAsset();
        }
      }
    });
  }

  public uploadPhotoClicker() {
    const dialogRef = this.dialog.open(MultimediaManagerComponent, { data: { multi: false } });
    dialogRef.beforeClosed().subscribe(
      (result) => {
        if (result) {
          this.updateBroadcastCenterBackgroundImage(result[0].Url);
        }
      }
    );
  }

  public setPreselected(op1, op2) {
    if (op1 && op2) {
      return op1.internalId === op2.internalId;
    }
  }

}
